<template>
  <div>
    <AdvancePaymentControls
      :value="search.typeData"
      @radioChange="updateSearchType"
      @newAdvance="handleNewAdvance"
    />
    <GeneralFilter
      :filterEndpoint="fetchPayments"
      :search="search"
      @emptyFilter="getAllPayments"
      @filtered="applyFilter"
    >
    <template v-slot:default>
      <div class="d-flex flex-column align-center flex-sm-row justify-sm-end py-2">
        <div class="mr-5 pb-1">
          <v-checkbox
              v-model="search.onlyActive"
              single-line
          >
            <template v-slot:label>
                <span>Solo activos</span>
            </template>
          </v-checkbox>
        </div>
        <div>
          <v-select 
            outlined
            dense
            v-model="search.branch"
            :items="branches"
            :item-text="getBranchLabel"
            attach
            item-value="ID_Branch"
            label="Sucursal"
          >
          </v-select>
        </div>
      </div>
      <AdvancePaymentTable 
        :advancedPayments="advancedPayments" 
        :win="win" 
        @update="getAllPayments"
      />
    </template>
    </GeneralFilter>
    <block v-if="loading" />
    <v-dialog
      v-model="isOpenAdvancePaymentDialog"
      scrollable
      :width="$vuetify.breakpoint.smAndDown ? '90%' : '90%'"
    >
      <AdvancePaymentForm
        v-if="isOpenAdvancePaymentDialog"
        @close="isOpenAdvancePaymentDialog = false"
        @success="showSuccessAlert"
      />
    </v-dialog>
    <Alert
      v-model="alert.show"
      @action="alert.action"
      :type="alert.type"
      :title="alert.title"
    >
      {{ alert.message }}
    </Alert>
  </div>
</template>

<script>
import GeneralFilter from "@/components/GeneralFilter.vue";
import Block from "@/components/Block.vue";
import AdvancePaymentTable from "./AdvancePaymentTable.vue";
import AdvancePaymentControls from "./AdvancePaymentControls.vue";
import AdvancePaymentForm from "./AdvancePaymentForm.vue";
import Alert from "../../../components/Alert.vue";

export default {
  name: "AdvancePaymentFilter",
  components: {
    GeneralFilter,
    AdvancePaymentTable,
    Block,
    AdvancePaymentControls,
    AdvancePaymentForm,
    Alert,
  },
  props: ["win"],
  data() {
    return {
      loading: false,
      advancedPayments: [],
      isOpenAdvancePaymentDialog: false,
      search: {
        ID_Customer: "",
        DatePayment: null,
        typeData: "01",
        onlyActive: true,
        branch: parseInt(JSON.parse(localStorage.getItem("user"))?.branch || 0)
      },
      alert: {
        show: false,
        action: null,
        type: "",
        title: "",
        message: "",
      },
      branches: [],
      role: JSON.parse(localStorage.getItem("user")).roles?.[0] || 'user',
    };
  },
  mounted() {
    this.getAllPayments();
    this.getBranches()
  },
  methods: {
    fetchPayments() {
      this.loading = true;
      return this.$API.customerAdvancePayment
        .findAllAdvancePayments(this.search)
        .then((response) => {
          this.advancedPayments = response.data;
          this.$emit("filtered", this.advancedPayments);
        })
        .catch((error) => {
          console.error("Error fetching payments:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showSuccessAlert(message) {
      this.alert.show = true;
      this.alert.type = "success";
      this.alert.title = "Éxito";
      this.alert.message = message;
      this.getAllPayments();
    },
    getAllPayments() {
      this.fetchPayments();
    },
    getBranches() {
      this.$API.branches
        .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
        .then((data) => {
          this.branches = [
            {
              BranchName: 'Todas',
              ID_Branch: 'all'
            },
            ...data
          ];
          //this.filters.branch = data[0].ID_Branch;
          if (this.search?.branch !== 0 && this.branches && !['ROLE_ADMIN','ROLE_ROOT'].includes(this.role)) {
              this.branches = this.branches.filter(e=> e.ID_Branch == this.search.branch)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBranchLabel(branch) {
      if (branch.ID_Branch === 'all') {
        return branch.BranchName
      } else {
        return `${branch.ID_Branch} - ${branch.BranchName}`
      }
    },
    applyFilter() {
      this.fetchPayments();
    },
    updateSearchType(newType) {
      this.search.typeData = newType;
      this.fetchPayments();
    },
    handleNewAdvance() {
      this.isOpenAdvancePaymentDialog = true;
    },
  },
};
</script>
